import { Component } from '@angular/core';
import { LoggerService } from '../services/logger.service';

@Component({
  selector: 'app-theme-container',
  templateUrl: './theme-container.component.html',
  styleUrls: ['./theme-container.component.scss']
})
export class ThemeContainerComponent {
  constructor(private logger: LoggerService) {
    this.logger.setName(this.constructor.name);
  }
}
